var TRY_AGAIN = 'Something unexpected happened.\nWe are trying to fix this as quickly as possible, so please try again later.';
// TODO: Need to localize these error messages
export var ERRORS = {
    clientError: {
        type: 'clientError',
        code: 'clientError',
        message: TRY_AGAIN,
        pendingRetry: false,
    },
    expiredLinkToken: {
        type: 'invalidLinkToken',
        code: 'expiredLinkToken',
        message: TRY_AGAIN,
        pendingRetry: false,
    },
    invalidLinkToken: {
        type: 'invalidLinkToken',
        code: 'invalidLinkToken',
        message: TRY_AGAIN,
        pendingRetry: false,
    },
    systemError: {
        type: 'systemError',
        code: 'systemError',
        message: TRY_AGAIN,
        pendingRetry: false,
    },
    timedOutWithNoBankInfo: {
        type: 'clientError',
        code: 'timedOutWithNoBankInfo',
        message: TRY_AGAIN,
        pendingRetry: false,
    },
    timedOutWithNoInput: {
        type: 'invalidUserInput',
        code: 'timedOutWithNoInput',
        message: TRY_AGAIN,
        pendingRetry: false,
    },
    networkError: {
        type: 'networkError',
        code: 'networkError',
        message: TRY_AGAIN,
        pendingRetry: false,
    },
};
